import { FileDownloadService } from './../../service/file-download.service';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { GoogleAnalysticsService } from 'src/app/shared/service/google-analystics.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-skill-sheet-button',
  templateUrl: './skill-sheet-button.component.html',
  styleUrls: ['./skill-sheet-button.component.scss']
})
export class SkillSheetButtonComponent implements OnInit, OnDestroy {
  @Input() workerMail: any;
  @Input() projectMail: any;
  @Input() page: string;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private fileDownloadService: FileDownloadService,
    private toastrService: ToastrService,
    private googleAnalysticsService: GoogleAnalysticsService
  ) { }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  createActionLog(type: string): void {
    const mail = this.workerMail || this.projectMail;
    let GAevent: string;
    if (type === 'skillsheet') {
      GAevent = 'スキルシートDL';
    } else if (type === 'eml') {
      GAevent = 'メールDL';
    } else {
    }
    this.googleAnalysticsService.eventEmit(
      GAevent,
      this.page,
      mail.ai_mail_id,
      0
    );

    const actionLogSub = this.fileDownloadService
      .saveActionLog(this.getMailParams(type))
      .subscribe(res => {});
    this.subscriptions.add(actionLogSub);
  }

  // スキルシートダウンロードボタンを押した時の処理(APIにメールファイルのリクエストを送る)
  downloadSkillSheet(url: string, file_name: string) {
    const downloadSkillSheetSub = this.fileDownloadService
    .requestSkillSheet(this.downloadSkillSheetParams(url, file_name))
    .subscribe(res => {
      // 受け取ったスキルシートをダウンロードする
      const blob = res.body;
      const fname_match: string[] = res.headers
      .get('Content-Disposition')
      .match(/filename="([^"]+)"/);
    const fname: string =
      fname_match === null || fname_match.length < 2
        ? 'スキルシート.zip'
        : fname_match[1];
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      a.download = decodeURI(fname);
      a.click();
      URL.revokeObjectURL(objectUrl);
    },
    err => {
      if (err.status === 404) {
        this.toastrService.error('エラーによりダウンロードできませんでした。再度お試しいただいてもエラーになる場合はサポートにご連絡ください');
      } else {
        this.toastrService.error('一時的な通信障害によりダウンロードに失敗しました。お手数ですが再度ボタンを押してください');
      }
    });
    this.subscriptions.add(downloadSkillSheetSub);
  }

  // メールダウンロードボタンを押した時の処理(APIにメールファイルのリクエストを送る)
  downloadMailFile() {
    const downloadMailFileSub = this.fileDownloadService
    .requestMailFile(this.downloadMailParams())
    .subscribe(res => {
      // 受け取ったメールファイルをダウンロードする
      const blob = res.body;
      const fname_match: string[] = res.headers
      .get('Content-Disposition')
      .match(/filename="([^"]+)"/);
    const fname: string =
      fname_match === null || fname_match.length < 2
        ? 'メールファイル.eml'
        : fname_match[1];
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      a.download = decodeURI(fname);
      a.click();
      URL.revokeObjectURL(objectUrl);
    },
    err => {
      if (err.status === 404) {
        this.toastrService.error('エラーによりダウンロードできませんでした。再度お試しいただいてもエラーになる場合はサポートにご連絡ください');
      } else {
        this.toastrService.error('一時的な通信障害によりダウンロードに失敗しました。お手数ですが再度ボタンを押してください');
      }
    });
    this.subscriptions.add(downloadMailFileSub);
  }

  // スキルシートのダウンロードに使うパラメータを返す
  downloadSkillSheetParams(url: string, file_name: string) {
    const params = {
      file_url: url,
      file_name: file_name
    };
    return params;
  }

  // メールファイルのダウンロードに使うパラメータを返す
  downloadMailParams() {
    const mail = this.workerMail || this.projectMail;
    const params = {
      mail_title: mail.title,
      rawdata_url: mail.rawdata_url,
      mail_from: mail.mail_from,
    };
    return params;
  }

  preventClickEvent(e) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }

  // 所持しているメールの情報を返す
  getMailParams(type: string) {
    if (this.workerMail) {
      const params = {
        ai_mail_id: this.workerMail.ai_mail_id,
        mail_type: 'worker',
        file_type: type,
        page: this.page
      };
      return params;
    } else {
      const params = {
        ai_mail_id: this.projectMail.ai_mail_id,
        mail_type: 'project',
        file_type: type,
        page: this.page
      };
      return params;
    }
  }

  openReader(file_info_url: string): void {
    const openReaderSub = this.fileDownloadService
    .requestFilePreviewUrl(this.requestFilePreviewUrlParams(file_info_url))
    .subscribe(res => {
      // 受け取ったurlでプレビューを開く
      var encodedUrl = encodeURIComponent(res.body.url);
      var openUrl = 'https://docs.google.com/gview?url=' + encodedUrl;
      window.open(openUrl);
    },
    err => {
      if (err.status === 404) {
        this.toastrService.error('ファイルが破損しているためダウンロードできませんでした。サポートチームに連絡してください');
      } else {
        this.toastrService.error('一時的な通信障害によりダウンロードに失敗しました。お手数ですが再度ボタンを押してください');
      }
    });
    this.subscriptions.add(openReaderSub);
  }

  // ファイルプレビュー用のパラメータを返す
  requestFilePreviewUrlParams(file_info_url: string) {
    const params = {
      file_url: file_info_url
    };
    return params;
  }

}
